import styled from 'styled-components';
import {getColor} from '@/styles/ThemeConfig';
import Image from 'next/image';
import React, {useEffect, useState} from "react";
import {breakpoints} from "@/styles/sizes";
import TICKET_ICON from '@/../public/images/ticket_icon.svg';

// Styled Components
const SectionContainer = styled.div`
    display: grid;
    grid-template-columns: ${props => props.$hasImage ? '1fr 1fr' : '1fr'};
    gap:50px;
  color: white;
    height: fit-content;
    @media only screen and (${breakpoints.mobile}) {
        padding: 20px;
    }

    @media only screen and (${breakpoints.mobile}) {
        grid-template-columns: 1fr;
        gap:0;
    }
    
`;

const Title = styled.h2`
  font-size: 36px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: bold;
  padding: 10px 0 20px;
  text-transform: uppercase;
  text-align: left;
    
    @media only screen and (${breakpoints.mobile}) {
        font-size: 25px;
    }
`;

const Description = styled.p`
  margin-bottom: 30px;
    font-family: 'Poppins'!important;
    font-size: 16px!important;
    
    p{
        font-size: 16px!important;
        font-family: 'Poppins'!important;
    }
`;

const LogoWrapper = styled.div`
  text-align: left;
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;


const CTA = styled.a`
  margin: 12px 0 24px;
  background: #144733;
  color: #fff;
  border: 0;
  padding: 14px 22px;
  font-size: 16px;
    max-width: 300px;
    line-height: 16px;
  cursor: pointer;
    text-decoration: none;
    
    display: flex;
    gap:10px;
    align-items: center;
    justify-content: center;


    /* Link */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 10px;

    width: 370px;
    height: 60px;

    background: #144733;

    /* Inside auto layout */
    flex: none;
    order: 3;
    flex-grow: 0;

    @media only screen and (${breakpoints.mobile}) {
        width:100%;
        max-width:100%;
    }
    
`;

// Main Component
export default function VariantBAboutSection({ title, description, image, footerData,ctaButtonData, ...rest }) {
    const [isClient, setIsClient] = useState(false);

    // Check if the component is rendering on the client
    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        (title &&
            description &&
            image) &&
            <div
                style={{
                    backgroundColor:getColor('gold'),
                    padding:'50px 0',
                }}
            >
                <div
                    className={'container_small'}
                >
                    <SectionContainer {...rest} $hasImage={!!image?.url}>
                        <div style={{width:'100%'}}>
                            <LogoWrapper>
                                <Image
                                    width={56}
                                    height={56}
                                    src={footerData?.logo?.url}
                                    alt={footerData?.logo?.alt ?? footerData?.logo?.name ?? 'Logo'}
                                    style={{ width: '56px', height: 'auto' }}
                                />
                            </LogoWrapper>

                            <Title>{title}</Title>
                            {isClient && <Description  dangerouslySetInnerHTML={{__html: description}}/>}

                            {
                                ctaButtonData &&
                                <CTA href={ctaButtonData?.item_link ?? '#'}>
                                    <Image src={TICKET_ICON} alt={'TICKET_ICON'} style={{}} />
                                    <div style={{paddingTop:'5px'}}>{'BOOK NOW!'}</div>
                                </CTA>
                            }
                        </div>


                        {
                            image?.url &&
                            <StyledImage
                                src={image?.url}
                                alt={image?.alt ?? image?.name}
                                width={520}
                                height={520}
                            />
                        }

                    </SectionContainer>
                </div>
            </div>
    );
}
